import { render } from "./iconUbicacion.vue?vue&type=template&id=44ec4bf4&scoped=true"
import script from "./iconUbicacion.vue?vue&type=script&lang=js"
export * from "./iconUbicacion.vue?vue&type=script&lang=js"

import "./iconUbicacion.vue?vue&type=style&index=0&id=44ec4bf4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-44ec4bf4"

export default script